<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col col="4">
          <v-card class="card-wrap">
            <v-card-title>{{ $t('ov.sys.title.cpu') }}</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <cpu
                :values="cpu"
                :system="system"
                :items="instances"
                :formatter="formatter.cpu"
                :max="100"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col col="4">
          <v-card class="card-wrap">
            <v-card-title>{{ $t('ov.sys.title.swap') }}</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <swap
                :values="swap"
                :system="system"
                :items="instances"
                :formatter="formatter.swap"
                :max="100"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import instanceable from '@/views/overview/system/abap/mixins/instanceable';
import contextmenuable from '@/views/overview/system/abap/mixins/contextmenuable';
import Cpu from '@/views/overview/system/chart/BarVertical.vue';
import Swap from '@/views/overview/system/chart/BarVertical.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    Cpu,
    Swap,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/abap/OperationSystem',
        title: this.$t('ov.sys.title.os'),
      },
      messages: [],
      messageSequence: 0,
      values: {
        cpu: {},
        memory: {},
        swap: {},
      },
      cpu: {},
      memory: {},
      swap: {},
      formatter: {
        cpu: param => `${param.value} %`,
        memory: param => `${param.value} %`,
        swap: param => `${param.value} %`,
      },
      contextmenuUrl: '/views/detailview/abap/os',
      selectedDescendant: {},
    };
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  computed: {
    ...mapState('common/properties', ['isPcapOs']),
  },
  methods: {
    contextmenuChart(event) {
      this.onContextmenuChart(event, this.selectedDescendant);
    },
    wsDataHandler(key, response) {
      ++this.messageSequence;

      response.forEach(res => {
        if (key.name == 'rawOsCpu' || key.name == 'pcapOsCpu') {
          if (this.isPcapOs) {
            this.values.cpu[key.instId] = Math.ceil(parseFloat(res.usrTotal) + parseFloat(res.sysTotal));
          } else {
            this.values.cpu[key.instId] = parseInt(res.usrTotal) + parseInt(res.sysTotal);
          }
        } else if (key.name == 'rawOsMem' || key.name == 'pcapOsMem') {
          if (this.isPcapOs) {
            this.values.memory[key.instId] = Math.ceil((parseInt(res.memUsed) / parseInt(res.memTotal)) * 100);
            this.values.swap[key.instId] = Math.ceil((1 - parseInt(res.swapFree) / parseInt(res.swapSize)) * 100);
          } else {
            this.values.memory[key.instId] = Math.ceil((1 - parseInt(res.freeMem) / parseInt(res.physMem)) * 100);
            this.values.swap[key.instId] = Math.ceil((1 - parseInt(res.swapFree) / parseInt(res.swapSize)) * 100);
          }
        }
      });

      // 시스템 별 취합 후 처리
      if (this.messageSequence == this.instances.length) {
        this.cpu = cloneDeep(this.values.cpu);
        this.memory = cloneDeep(this.values.memory);
        // console.log('in OperationSystem.vue, this.swap=', this.swap);
        this.swap = cloneDeep(this.values.swap);
        this.messageSequence = 0;
      }
    },
    sendMessage() {
      this.messages = [
        {
          name: this.isPcapOs ? 'pcapOsCpu' : 'rawOsCpu',
          fields: ['stime', 'usrTotal', 'sysTotal'],
        },
        {
          name: this.isPcapOs ? 'pcapOsMem' : 'rawOsMem',
          fields: this.isPcapOs ? ['stime', 'memTotal', 'memUsed', 'swapFree', 'swapSize'] : ['stime', 'freeMem', 'physMem', 'swapFree', 'swapSize'],
        },
      ];

      this.$websocket.realtime.send({
        requests: this.instances.reduce(
          (acc, instance) =>
            acc.concat(
              this.messages.map(message => ({
                key: { name: message.name, sstmId: instance.systemId, instId: instance.id },
                fields: message.fields,
                empty: false,
                handler: {
                  // buffer: this.wsBufferedDataHandler,
                  every: this.wsDataHandler,
                },
              })),
            ),
          [],
        ),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // value init
      Object.keys(this.values).forEach(key => {
        this.values[key] = {};
        this[key] = {};
      });
      // websoket message init
      this.wsRequestMessages = {};
    },
    changeInstancesHandler() {
      this.initialize();
      this.sendMessage();
    },
  },
};
</script>

<style scoped>
.chart-area {
  height: calc(100% - 37px);
}
</style>
